/*
 * Copyright 2020 Spotify AB
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { createPlugin, createRouteRef, createRoutableExtension } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'dash:root',
});

export const dashPlugin = createPlugin({
  id: 'dash',
});

export const DashPage = dashPlugin.provide(
  createRoutableExtension({
    name: 'Dash Home Page',
    component: () => import('./components/HomePage').then(m => m.default),
    mountPoint: rootRouteRef,
  }),
);
export const StatusPage = dashPlugin.provide(
  createRoutableExtension({
    name: 'Status',
    component: () => import('./components/StatusPage/StatusPage').then(m => m.StatusPage),
    mountPoint: rootRouteRef,
  }),
);
